export const styles = {
  qrContainer: {
    border: "1px solid",
    borderColor: "grey700",
    backgroundColor: "grey000",
    padding: "4px",
    borderRadius: "8px",
    width: "fit-content",
    mx: "auto",
  },
};
